import { TableColumn } from '/@/modules/core/table/models/TableColumn';
import { ColumnFormat } from '/@/modules/core/app/constants/data.constants';
import ActionCellRender from '/@/modules/core/table/models/ActionCellRender';

export class BaseColumns {
  /**
   * @var {TableColumn}
   */
  id;

  constructor() {
    this.id = new TableColumn({
      field: 'id',
      label: ' ',
      order: 100,
      visible: false,
      isPrimaryKey: true,
      format: ColumnFormat.FORMAT_ID,
      centered: true,
      sortable: false,
      meta: {
        cellRender: new ActionCellRender()
      }
    });
  }
}
